import { render } from "./UserExports.vue?vue&type=template&id=7bb41aa8"
import script from "./UserExports.vue?vue&type=script&lang=ts"
export * from "./UserExports.vue?vue&type=script&lang=ts"

import "./UserExports.vue?vue&type=style&index=0&id=7bb41aa8&lang=css"
script.render = render

export default script